import { State, useStore } from '@contexts/store'
import { Product } from '@framework/model-types/Product'
import { userWithoutToken } from '@helper/userWithoutToken'
import { Selected } from '@interfaces/banner'
import { useCallback } from 'react'

export const useAnalyticsEvents = () => {
  const { analytics, user } = useStore()

  const trackBannerClick = useCallback(
    (bannerOptions: Partial<Selected>) => {
      const bannerTitle = bannerOptions?.message?.title
      if (bannerTitle) {
        analytics.track('Banner action button clicked', {
          bannerTitle: bannerTitle,
        })
      }
    },
    [analytics],
  )

  const trackProductPopupViewed = useCallback(
    (product: Product) => {
      analytics.track('Product popup viewed', { ...product })
    },
    [analytics],
  )

  const trackAccountSignedIn = useCallback(
    (payload: { email: string }) => {
      analytics.track('Account Signed In', { ...payload })
    },
    [analytics],
  )

  const trackCheckoutStep1Completed = useCallback(
    (payload: {
      user: Omit<State['user'], 'token'>
      cartInfo: Record<string, any>
    }) => {
      analytics.track('Proceeded to payment', { ...payload })
    },
    [analytics],
  )

  const trackContactUsClick = useCallback(() => {
    analytics.track('Clicked on contact us', userWithoutToken(user))
  }, [analytics, user])

  return {
    trackBannerClick,
    trackProductPopupViewed,
    trackAccountSignedIn,
    trackCheckoutStep1Completed,
    trackContactUsClick,
  }
}
